<template>
  <div id="videoone">
    <el-tabs v-model="activeName" @tab-click="handleClick">
        <!-- <el-tab-pane :label="two" name="two">
            <span slot="label" v-if="activeName=='two'"><img src="../../../assets/img/power-active.png"></span>
            <span slot="label" v-else><img src="../../../assets/img/power.png"></span>
            <Distribution @wrid="isurl" ></Distribution>
            <DiaGram :src="apk"  :areaId="areaId" class="custom-class"></DiaGram>
        </el-tab-pane> -->
        
        <el-tab-pane :label="one" class="one" name="one">
            <span slot="label" v-if="activeName=='one'"><img src="../../../assets/img/3D-active.png"></span>
            <span slot="label" v-else><img src="../../../assets/img/3D.png"></span>
            <IfromD class="custom-thered"></IfromD
        ></el-tab-pane>
        <el-tab-pane :label="therr" name="three">
            <span slot="label" v-if="activeName=='three'"><img src="../../../assets/img/monitor-active.png"></span>
            <span slot="label" v-else><img src="../../../assets/img/monitor.png"></span>
            <Png :message="message" @getcode="getcode"></Png>
            <HomeVideo
            class="custom-one"
            :code="code"
            :videoList="videoList"
            @clickShow="clickshow"
            ></HomeVideo>
        </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import DiaGram from "../components/Diagram";
import Distribution from "./Distribution";
import IfromD from "./ifromD";
import { GetSecurityDevices, GET_AREAS } from "../../../api/common";
const HomeVideo = () => import('./HomeVideo.vue')
const Png = () => import('./png.vue')

export default {
  name: "videoone",
  data() {
    return {
      one: "3D",
      two: "配电图",
      therr: "监控",
      fullScreen: 0,
      message: "",
      areaId: 1,
      videoList: [],
      activeName: "one",
      apk: "",
      code:""
    };
  },
  created() {
    GET_AREAS(1).then((res) => {
      this.areaId = res.data.data.areas[0].areaId;  
      this.getDevicesData();
    });
  },
  mounted() {
    this.clickshow();
    // this.apk;
  },
  methods: {
    getcode(val){
      this.code = val
    },
    //显示影藏
    clickshow(val) {
      this.fullScreen = val;
      // console.log(this.fullScreen, "我是显示隐藏");
      if (this.fullScreen > 0) {
        this.one = "";
        this.two = "";
        this.therr = "";
      } else {
        this.one = "3D";
        this.two = "配电图";
        this.therr = "监控";
      }
    },
    //切换电路
    isurl(val) {
      this.apk = val;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //导航栏
    handleClick(tab, event) {
      // console.log( this.$store.state.homeitem.apk, this.$store.state.homeitem.monitoring)
      console.log(event);
    },
    getDevicesData() {
      GetSecurityDevices(this.areaId).then((res) => {
        let monitorArr = [];
        let id = 0;
        res.data.data.devices.map((item, index) => {
          if (item.device_class_name == "监控设备") {
            monitorArr.push({
              id: id++,
              videoName: item.device_name,
              videoCode: JSON.parse(item.device_details).roomName,
            });
          }
        });
        this.message = monitorArr; //传入PNG的值
        this.$store.commit("massageBug", this.message);
        this.videoList = monitorArr;
        // console.log(this.videoList, "测试");
      });
    },
  },
  components: {
    DiaGram,
    Distribution,
    HomeVideo,
    IfromD,
    Png,
  },
};
</script>
<style lang="less" scoped>
/deep/.el-tabs__content{
  position: static
}
#videoone {
  .w(1064);
  .h(640);
  // min-height: 500px;
  background-color: #ffffff;
  margin-bottom: 8rem;
  position: relative;
  .monitoringall {
    // display: none;
    z-index: 99;
    position: absolute;
  }

  .el-dropdown-link {
    width: 220rem !important;
    height: 100rem;
    font-size: 18rem;
    // color: #FFFFFF;
  }

  #pane-two {
    height: 100%;
  }
}

#inp {
  .w(248);
  .h(32);
  background: #ffffff;
  border: 1rem solid #000000;
  opacity: 0.15;
  border-radius: 16rem;
  margin-bottom: 16rem;
  margin-left: 16rem;
  //   margin-top: 16rem;
  padding: 5rem 18rem 4rem 15rem;
  display: flex;
  justify-content: space-between;
  #sousuo {
    .w(18);
    .h(18);
    background-color: black;
  }
  #div-inp {
    width: 248rem;
    height: 15rem;
    font-size: 16rem;
    margin-top: 0;
  }
}
</style>
